import React from 'react';
import { useSelector } from 'react-redux';

import { Avatar, Box, Typography, useTheme } from '@mui/material';
import PropTypes from 'prop-types';

import { getIsMobileLayoutForced, getIsNativePlatform } from 'utils/platform';

import { getMaster } from 'store/auth/selectors';

import { avatarStyles, getBoxStyles } from './UserAvatar.styles';
import { getInitialsColor, getInitialsVariant } from './UserAvatar.utils';

const UserAvatar = ({ size, withBorder = false }) => {
  const {
    data: { avatarDefault, photoURL },
  } = useSelector(getMaster);

  const { palette } = useTheme();
  const isNativeMobile = getIsNativePlatform() || getIsMobileLayoutForced();
  const isDarkWeb = palette.mode === 'dark' && !isNativeMobile;
  const initialsColor = getInitialsColor({ isNativeMobile, isDarkWeb });

  return (
    <Box sx={getBoxStyles({ size, withBorder, isNativeMobile })}>
      {photoURL ? (
        <Avatar alt="user photo" src={photoURL} sx={avatarStyles} />
      ) : (
        <Typography color={initialsColor} variant={getInitialsVariant(size)}>
          {avatarDefault}
        </Typography>
      )}
    </Box>
  );
};

UserAvatar.propTypes = {
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  withBorder: PropTypes.bool,
};

export default UserAvatar;
